export const ProIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="279"
      height="115"
      viewBox="0 0 279 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_245_272)">
        <rect
          x="-39.3047"
          y="12.9648"
          width="314.128"
          height="103.297"
          rx="51.6483"
          transform="rotate(-2.36385 -39.3047 12.9648)"
          fill="#101010"
        />
        <g clipPath="url(#clip1_245_272)">
          <path
            d="M83.3391 31.7945C74.6631 24.1329 63.1074 22.9678 58.4141 23.3429C49.6573 23.7643 41.1977 26.9403 33.7756 31.9803C26.3535 37.0203 17.9855 48.0919 17.7419 59.3018C17.4983 70.5118 21.5775 80.7808 32.2504 88.4929C42.9233 96.205 60.7753 102.391 69.5027 103.07C78.2302 103.75 86.4959 100.827 92.7708 95.0689C99.0457 89.3104 102.876 80.6969 102.395 70.7026C101.914 60.7084 94.1842 41.3714 83.3391 31.7945Z"
            fill="url(#paint0_linear_245_272)"
          />
          <path
            d="M77.68 77.6795L63.6483 78.3546C63.5352 78.3601 63.4753 78.2921 63.4685 78.1508L62.0759 48.326C62.0705 48.2129 62.1243 48.1537 62.2374 48.1482L76.1843 47.4772C76.2974 47.4717 76.3573 47.5397 76.3641 47.681L76.5977 52.5349C76.6031 52.6479 76.5493 52.7072 76.4362 52.7126L67.5339 53.1409L67.8603 59.9237L76.7626 59.4953C76.8756 59.4899 76.9349 59.5437 76.9403 59.6567L77.2193 64.5722C77.2248 64.6852 77.171 64.7445 77.0579 64.7499L68.1132 65.1803L68.4783 72.7685L77.423 72.3381C77.5361 72.3326 77.596 72.4006 77.6028 72.5419L77.8414 77.5017C77.8469 77.6148 77.7931 77.674 77.68 77.6795Z"
            fill="#FEFFFA"
          />
          <path
            d="M54.4178 78.7987L49.5215 79.0343C49.3943 79.0404 49.3274 78.9728 49.3206 78.8315L48.1294 54.0745L42.4912 54.3458C42.3499 54.3526 42.2759 54.2854 42.2691 54.1441L42.0779 49.2881C42.0725 49.1751 42.1263 49.1158 42.2393 49.1104L58.7298 48.317C58.8853 48.3095 58.9657 48.3623 58.9711 48.4753L59.2047 53.3292C59.2115 53.4705 59.1584 53.5439 59.0453 53.5493L53.3436 53.8237L54.5772 78.5786C54.584 78.7199 54.5308 78.7933 54.4178 78.7987Z"
            fill="#FEFFFA"
          />
        </g>
        <g filter="url(#filter0_f_245_272)">
          <ellipse
            cx="32.6052"
            cy="60.5907"
            rx="32.6052"
            ry="60.5907"
            transform="matrix(0.982659 0.185421 0.0193044 0.999814 272.943 -52.7119)"
            fill="#F61B0F"
          />
        </g>
      </g>
      <path
        d="M123.059 81.6275L121.199 36.5721L139.309 35.8246C148.801 35.4327 155.392 41.2909 155.774 50.5642L155.777 50.6267C156.16 59.9 150.074 66.2815 140.582 66.6733L131.902 67.0316L132.488 81.2383L123.059 81.6275ZM137.306 43.3823L130.937 43.6453L131.598 59.6629L137.967 59.4C143.369 59.177 146.435 56.1729 146.224 51.0523L146.221 50.9899C146.01 45.8692 142.708 43.1594 137.306 43.3823ZM162.588 79.9957L160.728 34.9404L179.337 34.1722C189.453 33.7546 195.67 38.8775 196.044 47.9323L196.046 47.9948C196.291 53.9272 193.341 58.9907 188.427 61.164L198.651 78.5071L187.972 78.9479L178.899 62.9647L171.343 63.2767L172.017 79.6065L162.588 79.9957ZM171.048 56.1265L179.197 55.7901C183.881 55.5967 186.581 52.8268 186.398 48.393L186.396 48.3306C186.218 44.0218 183.138 41.3965 178.486 41.5886L170.462 41.9198L171.048 56.1265ZM223.912 78.2462C210.517 78.7991 201.81 70.1822 201.219 55.8506L201.216 55.7882C200.624 41.4566 208.655 32.18 221.987 31.6296C235.351 31.078 244.089 39.6937 244.679 53.994L244.682 54.0564C245.273 68.388 237.306 77.6932 223.912 78.2462ZM223.582 70.253C231.075 69.9437 235.45 63.7892 235.065 54.4534L235.062 54.391C234.674 44.9927 229.717 39.3174 222.317 39.6228C214.948 39.927 210.444 45.9617 210.833 55.3912L210.835 55.4536C211.225 64.8831 216.182 70.5585 223.582 70.253Z"
        fill="#F61B0F"
      />
      <defs>
        <filter
          id="filter0_f_245_272"
          x="224.091"
          y="-96.9717"
          width="164.123"
          height="221.77"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="25"
            result="effect1_foregroundBlur_245_272"
          />
        </filter>
        <linearGradient
          id="paint0_linear_245_272"
          x1="37.3197"
          y1="10.9288"
          x2="126.51"
          y2="130.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED2F2F" />
          <stop
            offset="1"
            stopColor="#871B1B"
          />
        </linearGradient>
        <clipPath id="clip0_245_272">
          <rect
            x="0.306641"
            y="11.3298"
            width="274.483"
            height="103.297"
            rx="51.6483"
            transform="rotate(-2.36385 0.306641 11.3298)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_245_272">
          <rect
            width="84.9604"
            height="84.9604"
            fill="white"
            transform="translate(15.6953 24.8228) rotate(-2.75471)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
